module.exports = __webpack_public_path__ + "fonts/space-grotesk-medium.woff2";